const ISO3_LOCALE_MAP = {
  FRA: 'fr',
}

export function resolveLocaleFromIso3(iso3) {
  if (!iso3) return 'pt-BR'
  return ISO3_LOCALE_MAP[String(iso3).toUpperCase()] || 'pt-BR'
}
